import { useEffect, useState } from "react";
import LogoPage from "./components/pages/LogoPage";
import SignIn from "./components/pages/SignIn";

export default function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);
  return <>{isLoading ? <LogoPage /> : <SignIn />}</>;
}
